// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ltwjahlnrxdkhnghsfka.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx0d2phaGxucnhka2huZ2hzZmthIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwNDM2MTgsImV4cCI6MjA2OTYxOTYxOH0.zV5Gngnn2alyT0PzPFXNeSbxgjUSPRjOLzlaQXuttnQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// CRITICAL: Lazy initialization to prevent SSR/hydration crashes on mobile
// The client is only created when first accessed, not at module load time
let _supabaseClient: ReturnType<typeof createClient<Database>> | null = null;

const getSupabaseClient = () => {
  if (_supabaseClient) return _supabaseClient;
  
  // Safe checks for browser environment (critical for mobile compatibility)
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new Error('Supabase client must be used in browser environment');
  }
  
  // Safe storage wrapper - only use localStorage if available
  const safeStorage = typeof localStorage !== 'undefined' 
    ? localStorage 
    : undefined;

  _supabaseClient = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: safeStorage,
      persistSession: !!safeStorage, // Only persist if storage is available
      autoRefreshToken: true,
    }
  });
  
  return _supabaseClient;
};

// Export as a getter that works reliably on all mobile browsers
// Fallback implementation for browsers that don't support Proxy properly
export const supabase = new Proxy({} as ReturnType<typeof createClient<Database>>, {
  get: (_target, prop) => {
    try {
      const client = getSupabaseClient();
      return (client as any)[prop];
    } catch (error) {
      console.error('Supabase client initialization error:', error);
      throw error;
    }
  }
});